import React, { useEffect, useRef, useState } from "react";
import { ACTIONS } from "../Actions";

function Chat({ socketRef, roomId, username }) {
  const [messages, setMessages] = useState([]);
  const [msg, setMsg] = useState("");
  const messagesEndRef = useRef(null);

  const formatTime = (value) => {
    if (!value) return "";
    if (typeof value === "string" && value.includes(":")) return value;
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return "";
    return parsed.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  };

  useEffect(() => {
    if (!socketRef.current) return;

    const onChatMessage = (data) => {
      setMessages((prev) => [...prev, data]);
    };

    socketRef.current.on(ACTIONS.CHAT_MESSAGE, onChatMessage);

    return () => {
      socketRef.current?.off(ACTIONS.CHAT_MESSAGE, onChatMessage);
    };
  }, [socketRef]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const sendMessage = () => {
    if (!msg.trim()) return;

    const data = {
      roomId,
      username,
      message: msg,
      time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
    };
    socketRef.current.emit(ACTIONS.CHAT_MESSAGE, data);
    setMessages((prev) => [...prev, data]);
    setMsg("");
  };

  return (
    <div className="chat-container">
      <div className="chat-header">💬 Room Chat</div>

      <div className="chat-messages">
        {messages.map((m, i) => (
          <div key={i} className="chat-message">
            <div className="chat-meta">
              <span className="chat-username">{m.username}</span>
              <span className="chat-time">{formatTime(m.time)}</span>
            </div>
            <span className="chat-text">{m.message}</span>
          </div>
        ))}
        <div ref={messagesEndRef}></div>
      </div>

      <div className="chat-input-box">
        <input
          type="text"
          value={msg}
          placeholder="Type message..."
          onChange={(e) => setMsg(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && sendMessage()}
        />
        <button onClick={sendMessage}>Send</button>
      </div>
    </div>
  );
}

export default Chat;
